export default {
    name: 'rooms'
}